import { PointerWithRecord } from "libs/schema";
import { IListOnEntryActionEvent, IListRef } from "~/components/list";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { isModKeyActive } from "~/environment/command.service";
import { UnreachableCaseError } from "libs/errors";
import { IThreadViewContext } from "../thread/context";
import { useMemo } from "react";

export type TRequestsEntry = PointerWithRecord<"thread">;

/* -----------------------------------------------------------------------------------------------*/

export async function onRequestsEntrySelect(
  environment: Pick<ClientEnvironment, "router">,
  props: {
    event: IListOnEntryActionEvent<TRequestsEntry>;
  },
) {
  const { event } = props;

  switch (event.entry.table) {
    case "thread": {
      return environment.router.navigate(`/requests/threads/${event.entry.record.id}`, {
        openInNewTab: isModKeyActive(event.event),
      });
    }
    default: {
      throw new UnreachableCaseError(event.entry.table);
    }
  }
}

/* -----------------------------------------------------------------------------------------------*/

export function useRequestsViewThreadContext(props: { listRef: React.RefObject<IListRef<TRequestsEntry>> }) {
  const { listRef } = props;

  return useMemo((): IThreadViewContext => {
    return { threadList: { type: "requests", ref: listRef } };
  }, [listRef]);
}

/* -----------------------------------------------------------------------------------------------*/
